import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypingEffectDirective } from './typing-effect.directive';
import { DynamicColumnDirective } from './dynamic-column.directive';



@NgModule({
  declarations: [
    // TypingEffectDirective
  
    DynamicColumnDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
